import React from 'react';
import Divider from 'src/components/ui/Divider/Divider';
import OptionItemList from 'src/components/ui/OptionItemList/OptionItemList';
import { OptionItemProps } from 'src/components/ui/OptionItem/OptionItem';
import styles from './ActionMenu.module.scss';

export type ActionMenuProps = {
  items: OptionItemProps[];
  displayDivider?: boolean;
};

const ActionMenu: React.FC<ActionMenuProps> = ({ items, displayDivider = true }) => {
  const firstMenuItems = items.slice(0, -1);
  const secondMenuItem = items.slice(-1);

  return (
    <div className={styles.root}>
      {items && items.length > 1 ? (
        <>
          <OptionItemList items={firstMenuItems} />
          {displayDivider && <Divider className="my-8 mx-12" customColor="border-subtle-transparent" />}
          <OptionItemList items={secondMenuItem} />
        </>
      ) : (
        <OptionItemList items={items} />
      )}
    </div>
  );
};

export default ActionMenu;
